import React from "react";
import "./index.css";

const NotFound = () => {
  return (
    <>
      <h1 className="not-found-code">404</h1>
      <h3 className="not-found-title">Page Not Found</h3>
      <p className="not-found-text">
        The resource requested could not be found on this server!
      </p>
    </>
  );
};

export default NotFound;
